export default class Navigation {
  constructor(dom) {
    this.dom = dom;
    this.updateNavHeightCssVar();
    window.addEventListener("resize", () => this.resize());
  }

  setHideOnScroll() {
    this.hidden = false;
    this.oldTop = window.scrollY;
    window.addEventListener("scroll", () => {
      let currTop = window.scrollY;
      if (currTop > this.oldTop + 10 && this.hidden == false) {
        this.hideElement();
      } else if (currTop < this.oldTop - 5 && this.hidden == true) {
        this.showElement();
      }
      this.oldTop = currTop;
    });
  }

  hideElement() {
    this.dom.classList.add("shy");
    this.hidden = true;
  }

  showElement() {
    this.dom.classList.remove("shy");
    this.hidden = false;
  }

  updateNavHeightCssVar() {
    document.body.style.setProperty(
      "--navHeight",
      `${this.dom.clientHeight}px`
    );
  }

  handleMenuControl() {
    let hamBurBtn = this.dom.querySelector("[js-navHamBtn]");
    let menu = this.dom.querySelector("[js-menuwrap]");
    let menuItems = this.dom.querySelectorAll("[js-menu-item]");

    hamBurBtn.addEventListener("click", () => {
      hamBurBtn.classList.toggle("opened");
      menu.classList.toggle("opened");
      //fadein
      setTimeout(() => {
        let menuitems = this.dom.querySelectorAll("[js-menu-fade]");
        for (let [i, mitem] of menuitems.entries()) {
          setTimeout(() => {
            mitem.classList.toggle("this-trigger");
          }, 150 * i);
        }
      }, 150);
    });
    // close menu when click menu item
    for (let [i, menuEl] of menuItems.entries()) {
      menuEl.addEventListener("click", () => {
        hamBurBtn.classList.remove("opened");
        menu.classList.remove("opened");

        //fadeout
        setTimeout(() => {
          let menuitems = this.dom.querySelectorAll("[js-menu-fade]");
          for (let [i, mitem] of menuitems.entries()) {
            setTimeout(() => {
              mitem.classList.remove("this-trigger");
            }, 150 * i);
          }
        }, 150);
      });
    }

    window.scrollTo(0, top);
  }

  resize() {
    // this.updateNavHeightCSSVar();
    // console.log("resize from Navigation.js");
  }
}
